import { render, staticRenderFns } from "./Music.vue?vue&type=template&id=114e0632&scoped=true&"
import script from "./Music.vue?vue&type=script&lang=js&"
export * from "./Music.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114e0632",
  null
  
)

export default component.exports